window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
theme.Custom = {
  drawertoggle: function(cls) {
    document.querySelector(cls).classList.toggle('active');
    document.querySelector('body').classList.toggle('drawer-open');
    return document.querySelector('.overlay').classList.toggle('active');
  },

  docBreakPoint: function() {
    return window.getComputedStyle(document.documentElement, ":after").getPropertyValue("content").replace(/"/g, "")
  },

  isBreakpoint: function(t) {
    return theme.Custom.docBreakPoint() === t
  },

  getBreakpoint: function(t) {
    return theme.Custom.docBreakPoint()
  }

};

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.ProductSection = (function() {
  function ProductSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productFeaturedImage: '.product-featured-img',
      productThumbsWrapper: '.thumbnails-wrapper',
      productDetails: '.product-description',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      productSlider: '.product-slider',
      salePrice: '[data-sale-price]'
    };

    this.classes = {
      productOnSale: 'price--on-sale',
      productUnavailable: 'price--unavailable'
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    //this._shopZoneCheck();
    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initSexySelect();

    this._initImageSwitch();
    this._setActiveThumbnail();
  }

  ProductSection.prototype = $.extend({}, ProductSection.prototype, {
    _shopZoneCheck: function() {
      console.log('_shopZoneCheck');
      var self = this,
      el = this.selectors.addToCart,
      blockerCls = 'freezone',
      targetEl = this.selectors.addToCart + '.' + blockerCls;
      if(getCookie("shop_zone") === 'FREE') {
        $(this.selectors.addToCart).addClass(blockerCls);
      } else {
        $(this.selectors.addToCart).removeClass(blockerCls);
      }
      $(document).on('click', targetEl, function(e){
        e.preventDefault();
        $('.overlay').removeClass('active');
        clearZoneCookie();
        console.log('Open cookie popup: Please select zone');
        setTimeout(
          openLocationPopup(),
          500
        )
      });

      function clearZoneCookie(){
        var d = new Date();
        document.cookie = "shop_zone=none; expires="+d.toUTCString()+"; path=/";
        console.log('clearZoneCookie..............');
      }

      function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
      }
    },
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          self._initProductSlider();
          self._initImageSlider(self);
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          var imobj = document.querySelectorAll(self.selectors.productFeaturedImage);
          imobj&& $.each(imobj, function(e,t){
            e>0&&t.classList.add('img-hide');
          });

          self._destroyProductSlider();
          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          self._initImageSlider(self);
          self._productDetailsClass();
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _productDetailsClass: function() {
      if (theme.Custom.isBreakpoint("L")) {
        //console.log($(this.selectors.productImage, this.$container).outerHeight());
        //console.log($(this.selectors.productImageWraps, this.$container).outerHeight());
        var t = $(this.selectors.productImageWraps, this.$container).outerHeight(),
          e = $(this.selectors.productDetails, this.$container).outerHeight(),
          n = window.innerHeight,
          i = $(this.selectors.Pageheader).outerHeight() || 0,
          o = n - i;
          this.settings.isSticky = t > o && e < o
          //this.settings.isSticky = t > o
          } else this.settings.isSticky = !1;
          //console.log(t + '>' + o + '&&' +  e + '<' +  o);
          $(this.selectors.productDetails, this.$container).toggleClass("product-details-sticky", this.settings.isSticky);
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initSexySelect: function() {
      $(this.selectors.singleOptionSelector).prettyDropdown({
        classic: true,
        selectedMarker: ''
      });
      this._addNotifyMe();
    },

    _addNotifyMe: function() {
      var variants = this.productSingleObject.variants;
      var el = document.querySelector('#prettydropdown-SingleOptionSelector-0');
      el && variants.forEach(function(variant) {
        if(variant.available == false) {
          var sel = "li[data-value='" + variant.option1 + "']";
          var el = document.querySelector(sel);
          el.classList.add('notify-me')
          var itxt = el.innerText;
          el.innerText = variant.option1.toUpperCase() + " - Notify me";
        }
      });
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);

        var imageId = $el.data('thumbnail-id');

        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);
      });
    },

    _setActiveThumbnail: function(imageId) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.mobile-show')").data(
          'image-id'
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(activeClass)
        .removeAttr('aria-current');

      $thumbnail.addClass(activeClass);
      $thumbnail.attr('aria-current', true);
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      $newImage.removeClass('mobile-show');
      $newImage.find(this.selectors.productFeaturedImage).focus();
      $otherImages.addClass('mobile-show');
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-list')
        .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-disabled')
        .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex');
    },

    _initProductSlider: function() {
     // console.log('_initProductSlider');
     var self = this,
        options = {
        dots: false,
        arrows: false,
        infinite: false,
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable:true,
        vertical: false,
        verticalSwiping: false
      };

      setTimeout(function(el) {
        //document.addEventListener('lazybeforeunveil', function(e){
          var imobj = document.querySelectorAll(self.selectors.productFeaturedImage);
          imobj&& $.each(imobj, function(e,t){
            e>0&&t.classList.remove('img-hide');
          });
          $(el).slick(options);
       // });
      }, 500, this.selectors.productSlider);
    },

    _destroyProductSlider: function() {
      $(this.selectors.productSlider).slick('unslick');
    },

    _initImageViewerSlider: function(self) {
     // console.log('_initImageViewer');
      var owlSlide = '';

      var images = [];
      $(self.productSingleObject.images).each(function(i, e){
        var x = {
          small : slate.Image.getSizedImageUrl(e, '1024x'),
          big : e
        }
        images.push(x);
      });

      $(document).on("click", ".iv-close", function(event) {
        event.preventDefault();
        var i = document.querySelectorAll('#image-gallery-2 img');
        i && $.each(i, function(i,t) {
          t.classList.add('mobile-show');
        });
      });

      var curImageIdx = 1,
        total = images.length;
      var wrapper = $('#image-gallery-2'),
        curSpan = wrapper.find('.current');
      //var viewer = ImageViewer(wrapper.find('.image-container'));

      function showImage(){
          var imgObj = images[curImageIdx - 1];
          viewer.show(imgObj.big);
          var i = document.querySelectorAll('#image-gallery-2 img');
          i && $.each(i, function(i,t) {
            t.classList.remove('mobile-show');
          });
      }

      wrapper.find('.next-img').click(function(){
           curImageIdx++;
          if(curImageIdx > total) curImageIdx = 1;
          showImage();
      });

      wrapper.find('.prev-img').click(function(){
           curImageIdx--;
          if(curImageIdx < 0) curImageIdx = total;
          showImage();
      });

      //showImage();

      var viewer = ImageViewer({
          zoomValue: 100,
          snapView: true,
          maxZoom: 200,
          movable: true,
          refreshOnResize: true,
          zoomOnMouseWheel : true
        });

      $(document).on("click", '.product--img', function () {
        var count = $(this).data('imgcount');
        var imgObj = images[count];
        showImage();
      });
    },

    _initImageViewer: function(self) {
      var viewer = ImageViewer({
          zoomValue: 100,
          snapView: true,
          maxZoom: 100,
          refreshOnResize: true,
          zoomOnMouseWheel : true
        });

        $('.product-featured-img').click(function () {
          var highResolutionImage = $(this).data('high-res-src');
          viewer.show(highResolutionImage);
        });

      /*$('.zoom-image').ImageViewer({
          zoomValue: 800,
          snapView: true,
          maxZoom: 1200,
          refreshOnResize: true,
          zoomOnMouseWheel : true
        });*/
    },

    _initImageSlider: function(self) {
      //console.log('_initImageSlider');
        $(".product-single__photo").click(function(){
          var total_popup = $('img.product-single__thumbnail-image').length;
          var counter = $(".product-single__thumbnail.active-thumb > img").attr("value");
          $(".popup-overlay.product-popup").addClass("active");console.log("counter : "+counter);
          var img_src = $(".product-single__thumbnail.active-thumb > img").attr('data-img');
          $('.popup-overlay.product-popup .product-view img').attr('src',img_src);
          if(counter==parseInt(total_popup)-1)
          {
            var next_popup = 0;
          }
          else
          {
            var next_popup = parseInt(counter)+1;
          }

          if(counter==0)
          {
            var previous_popup = parseInt(total_popup)-1;
          }
          else
          {
            var previous_popup = parseInt(counter)-1;
          }
          $('.product_slider.previous').attr('value',previous_popup);
          $('.product_slider.next').attr('value',next_popup);
        });

        $('.slider_anchor_2.product_slider.next').click(function(){
            var total_popup = $('img.product-single__thumbnail-image').length;
            var counter = $(".slider_anchor_2.product_slider.next").attr("value");

            if(counter==parseInt(total_popup)-1)
            {
              var next_popup = 0;
            }
            else
            {
              var next_popup = parseInt(counter)+1;
            }

            if(counter==0)
            {
              var previous_popup = parseInt(total_popup)-1;
            }
            else
            {
              var previous_popup = parseInt(counter)-1;
            }
            var img_src = $('#img_'+counter).attr('data-img');

            $('.enquiry-form').addClass('hide');
            $('a.btn.btn-text').removeClass('hide');
            $('.slider_anchor_2.product_slider.previous').attr('value',previous_popup);
            $('.slider_anchor_2.product_slider.next').attr('value',next_popup);
            $('body').addClass('drawer-open');
            $('.popup-overlay.product-popup .product-view img').attr('src',img_src);
            $('.popup-overlay.product-popup').addClass('active');
        });

        $('.slider_anchor_2.product_slider.previous').click(function(){
            var total_popup = $('img.product-single__thumbnail-image').length;
            var counter = $(".slider_anchor_2.product_slider.previous").attr("value");

            if(counter==parseInt(total_popup)-1)
            {
              var next_popup = 0;
            }
            else
            {
              var next_popup = parseInt(counter)+1;
            }

            if(counter==0)
            {
              var previous_popup = parseInt(total_popup)-1;
            }
            else
            {
              var previous_popup = parseInt(counter)-1;
            }
            var img_src = $('#img_'+counter).attr('data-img');

            $('.enquiry-form').addClass('hide');
            $('a.btn.btn-text').removeClass('hide');
            $('.slider_anchor_2.product_slider.previous').attr('value',previous_popup);
            $('.slider_anchor_2.product_slider.next').attr('value',next_popup);
            $('body').addClass('drawer-open');
            $('.popup-overlay.product-popup .product-view img').attr('src',img_src);
            $('.popup-overlay.product-popup').addClass('active');
        });
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = slate.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = slate.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart).show();
          $(this.selectors.addToCart).prop('disabled', false);
          var nfl = document.querySelector('.notify-me-link');
          nfl && nfl.remove();
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCart).hide();
          //var htmllink = '<a href="mailto:'+ theme.strings.notifyEmail +'?subject=Notify me when PRODUCT '+ variant.name +' is back in stock" class="notify-me-link btn btn-dark">'+theme.strings.soldOut+'</a>';
          var htmllink = '<a href="#" class="notify-me-link btn btn-dark">'+theme.strings.soldOut+'</a>';
          //$(this.selectors.addToCart).html(htmllink);
          if($('.notify-me-link').length <1){
            $(this.selectors.addToCart).parent().append(htmllink);
          }

          //$(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateAvailability: function(evt) {
      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeAttr('aria-hidden');

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr('aria-hidden', true);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          slate.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          slate.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

$(".colour-swatches-products").on("click", ".active", function() {
    $(this).closest(".colour-swatches-products").children('li:not(.active)').toggle();
});

$(".lable-size").on("click", function() {
    $('.eyefitu-size-recommendation-button').click();
});

$(".colour-swatches-products").on("mouseleave", function() {
    $(this).closest(".colour-swatches-products").children('li:not(.active)').hide();
});

  return ProductSection;
})();

theme.CustomFilters = {};
theme.CustomFilters = (function() {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterSelection: '#SortTags',
    sortSelection: '#SortBy',
    defaultSort: '#DefaultSortBy',
    filterWrapper: '.filter-option',
    filterOptions: '.filters-list a',
    filterPopupClose: '.filter-close',
    filterRemove: '.rt-text a.remove_tags',
    filterRemoveAll: '.rt-text span.clear',
    autofilter: true,
    productBlock: '.product-block',
    activeFilter: '.filters-list a.active'
  };

  function CustomFilters(container) {
    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)'
    };
    var $container = (this.$container = $(container));

    this.$customFilter = $(selectors.filterOptions, $container);
    this.$customFilterDisplay = $(selectors.filterPopupClose, $container);
    this.$customFilterRemove = $(selectors.filterRemove, $container);
    this.$customFilterRemoveAll = $(selectors.filterRemoveAll, $container);
    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );
    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');
    self = this;

    self._initBreakpoints();

    this.$customFilter.on('click', function(e){
      e.preventDefault();
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $(this).addClass('active');
      }
      self._CustomFilter();
    });

    this.$customFilterDisplay.on('click', function(e){
      e.preventDefault();
      //close popup
      $(this).removeClass('active');
      self._CustomFilter();
    });

	$(document).on('click', selectors.filterRemoveAll, function(e){
      e.preventDefault();
      var filters = document.querySelectorAll(selectors.activeFilter);
      $.each(filters, function(i,item) {
        $(this).removeClass('active');
      });
		$("#layout_expended").addClass('active');
      self._CustomFilter();
      self._SavedFilter();
    });

    $(document).on('click', selectors.filterRemove, function(e){
      e.preventDefault();
      var tag =  $(this).attr('data-value');
      var filters = document.querySelectorAll(selectors.activeFilter);
      $.each(filters, function(i,item) {
        var pcls = $(this).parent().attr('class');
        //console.log(pcls+'>>>>>>>>'+tag);
        //if(pcls == tag) {
          if(pcls.indexOf(tag) != -1) {
          //console.log('called');
          $(this).removeClass('active');
        }
      });
      self._CustomFilter();
      self._SavedFilter();
    });

    if (selectors.autofilter) {
      this._autoFilter();
      this._SavedFilter("hide");
    }

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  CustomFilters.prototype = $.extend({}, CustomFilters.prototype, {
    _initBreakpoints: function() {
      var self = this;
      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          console.log("mediaQuerySmall");
          document.querySelector('.filter-toggle-block').classList.remove('active');
          document.querySelector('.filter').classList.remove('active');
        },
        unmatch: function() {
          console.log("mediaQuerySmall unmatch");
          document.querySelector('.filter-toggle-block').classList.add('active');
          document.querySelector('.filter').classList.add('active');
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          document.querySelector('.filter-toggle-block').classList.add('active');
          document.querySelector('.filter').classList.add('active');

        }
      });
    },

    _autoFilterTemplate: function() {
      var a = sessionStorage.getItem("autofilter"), el = a.split('/'), f = el[el.length-1];
      if(a) {
        f = f.split('?')[0];
        f = f.split('+');
        $.each(f, function(i,v) {
          v && document.querySelector('li.' + v + ' a').classList.add('active');
        });
        self._CustomFilter();
        } else {
        self._showFilteredItems();
        }
    },

    _autoFilter: function() {

      var key = 'autofilter' + document.location.pathname.split('/').join('_');
      a = sessionStorage.getItem(key);
      if(a) {
        this._showActiveFilters(a);
        this._customFiltersByClass(a);
        //this._hideAllProductBlocks();
        //this._showFilteredItems(a);
      }
      else {
        this._showAllProductBlocks();
      }
    },

    _CustomFilter: function() {
      self = this;
      var filters = document.querySelectorAll(selectors.activeFilter);
      var selEl = [];
      $.each(filters, function(i,item) {
        var result = item.href.split('/');
        selEl.push(result[5]);
      });
      var selectedFilters = selEl.join("+");
      // Filter products via default shopify filter with custom view template
      //self._customTemplateFilter(selectedFilters);
      var key = 'autofilter' + document.location.pathname.split('/').join('_');
      sessionStorage.setItem(key, selectedFilters);
      self._customFiltersByClass(selectedFilters);
      self._SavedFilter("hide");
    },

    _SavedFilter: function(actions) {

        var filters = document.querySelectorAll(selectors.activeFilter);
        var selEl = [];
       var xArray = [];
       var yArray = [];
        $.each(filters, function(i,item) {

          var result = item.href.split('/');
          var options = result[5].split('_');
          selEl.push(result[5]);
          if(options[0] == 'size') {
            xArray.push(result[5]);
          } else {
            yArray.push(result[5]);
          }
        });
        //console.log(selEl);
        var links = [];

        // Colors
        if(yArray.length) {
          links.push('<div class="filter-option"><h2>Colour</h2><ul>');
          $.each(yArray, function(i,item) {
            var result1 = item.split('_');
            links.push('<li class="rt-text check-custom '+ item +'"><a data-value='+item+' href="#" class="remove_tags active">'+result1[1]+'</a></li>')
          });
          links.push("</ul></div>");
        }
        //Size
        if(xArray.length) {
          links.push('<div class="filter-option"><h2>Size</h2><ul>');
          $.each(xArray, function(i,item) {
            var result1 = item.split('_');
            links.push('<li class="rt-text check-custom '+ item +'"><a data-value='+item+' href="#" class="remove_tags active">'+result1[1]+'</a></li>')
          });
          links.push("</ul></div>");
        }
        $(".mobile-clear-filters").addClass("hide");
        if (links.length != 0) {
          links.push('<div class="rt-text"><span class="clear" style="cursor: pointer;">Clear Filters</span></div>');
          $(".mobile-clear-filters").removeClass("hide");
          $(".mobile-clear-filters").addClass("show");
        }
        var LinkfullUrl = links.join("");
        var lnk = document.querySelector("#filter_update");
        if(actions == 'hide') {
          $("#filter_update").html('');
          return true;
        }
        lnk.innerHTML = LinkfullUrl;
    },

     _getLargestArrayElement: function(arr) {
        var largest = 0, el= 0;
        for (var i = 0; i < arr.length; i++) {
          //console.log(i + ' >>>>>>> ' + arr[i]);
          if(arr[i].length >  largest) {
          largest = arr[i].length;
            el = i
          }
        }
        return el;
     },

     _getFinalClsArrayCount: function(arr) {
        var largest = 0, el= 1;
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].length) {
            el = el * arr[i].length;
          }
        }
        return el;
     },

    _clsCombination: function(arr) {
      if (arr.length == 1) {
        return arr[0];
      } else {
        var result = [];
        var allCasesOfRest = this._clsCombination(arr.slice(1));  // recur with the rest of array
        for (var i = 0; i < allCasesOfRest.length; i++) {
          for (var j = 0; j < arr[0].length; j++) {
            result.push(arr[0][j] + ' ' + allCasesOfRest[i]);
          }
        }
        return result;
      }
     },
    _customFiltersByClass: function(selectedFilters){
      if (selectedFilters.length>0){
      	self._hideAllProductBlocks();

      var ma = [];
      var filters = document.querySelectorAll(selectors.filterWrapper);
      $.each(filters, function(i,item) {
        var tempArray = [];
        var list = this.querySelectorAll(selectors.activeFilter);
        $.each(list, function(i,data) {
           tempArray.push(this.getAttribute('data-attr-tag'));
        });
        if(tempArray.length) ma.push(tempArray);
      });
      //console.log(this._clsCombination(ma));
      if(this._clsCombination(ma)) {
        var filterCls =  this._clsCombination(ma);
         $.each(filterCls, function(i,item) {
          var res = item.replace(/ /g, ".");
           $("." + res).closest('.product-block').removeClass('hide');
         });
      }
/*      else {
        self._showAllProductBlocks();
      }

        var filterSizes = [];
        var filterColours = [];
        var sizeClasses ='';

        //split by Colour and Size
        $.each(selectedFilters.split('+'), function(i,filter) {
          if (filter.includes('colour_')){filterColours.push(filter);}
          if (filter.includes('size_')){
              filterSizes.push(filter);
              sizeClasses += '.filt_'+filter+' ';
          }
        });
        //console.log(filterSizes);
        //console.log(filterColours);


        if((filterSizes.length > 0)&&(filterColours.length > 0)){

          //show colours that are in the requested sizes.
          $.each(filterColours, function(i,colour) {
            $.each(filterSizes, function(i,size) {
              seekClass = ('.filt_'+colour+'.filt_'+size);
              //console.log(seekClass)
              $(seekClass).closest('.product-block').removeClass('hide');
            })
          });
        }else if(filterColours.length > 0){
          $.each(filterColours, function(i,colour) {
            seekClass = ('.filt_'+colour);
            $(seekClass).closest('.product-block').removeClass('hide');
          });
        }else if(filterSizes.length > 0){
          $.each(filterSizes, function(i,size) {
            seekClass = ('.filt_'+size);
            $(seekClass).closest('.product-block').removeClass('hide');
          });
        }*/

        //self._showFilteredItems(selectedFilters);
      } else {
        self._showAllProductBlocks();
      }
    },

    _customTemplateFilter: function(selectedFilters) {
      var view = '?view=grid', vt = document.querySelectorAll('.view-type');
      vt && $.each(vt, function(e,t){
        if (t.classList.contains('active')) {
          view = '?view=' + t.getAttribute('data-view-type');
        }
      });

      var url = window.location.pathname +'/'+ selectedFilters + view;
      localStorage.setItem("autofilter", url);
      var e = document.querySelector(".product-list-block");

      $.ajax({
        type: "GET",
        url:url,
        success: function(t) {
          //console.log(t);
          e && (e.innerHTML = t);
          //Currency.convertAll('GBP', jQuery('[name=currencies]').val());
        },
        complete: function(r) {
          self._showFilteredItemsTemplate();
        //   window.doReScroll();
         }
      });

    },

    _hideAllProductBlocks: function(){
      var pb = document.querySelectorAll(selectors.productBlock);
      pb && $.each(pb, function(e,t) {
        if(!t.classList.contains('hide')) {
          t.classList.add('hide');
        }
      });
    },

    _showAllProductBlocks: function(){
      var pb = document.querySelectorAll(selectors.productBlock);
      pb && $.each(pb, function(e,t) {
        t.classList.remove('hide');
      });
    },

    _showActiveFilters:function(selectedFilters) {
      var filtersAry = selectedFilters.split('+');
      for (var i = 0; i < filtersAry.length; i++) {
        var cls = '.' + filtersAry[i] + ' a';
        var ac = document.querySelector(cls).classList.add('active');
      }
    },

    _showFilteredItems: function(selectedFilters) {
      if(!selectedFilters) {
        this._showAllProductBlocks();
      }
      var blocksAry = [], i = document.querySelectorAll(selectors.productBlock),
      filtersAry = selectedFilters.split('+');
      i && $.each(i, function(j,k) {
        var el = k.querySelector('.img-block');
        for (var i = 0; i < filtersAry.length; i++) {
          var cls = 'filt_' + filtersAry[i];
          if (el.classList.contains(cls)) {
            blocksAry.push(el.getAttribute("data-product-id"));
          }
        }
      });

      //unique Array
      blocksAry = $.grep(blocksAry, function(v, k){
          return $.inArray(v ,blocksAry) === k;
      });

      $.each(blocksAry, function(e,i){
        var sel = '.product-' + i;
        document.querySelector(sel).classList.remove('hide');
      });
    },

    _showFilteredItemsTemplate: function(){
      var i = document.querySelectorAll(selectors.productBlock),
      b =  document.querySelectorAll('.pgv-block.grid-view-item');
      i && $.each(i, function(j,k){
        k.classList.remove('hide');
      });
      b && $.each(b, function(j,k){
        k.classList.remove('hide');
      });
    },

    _onSortChange: function(evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(
          window.location.search,
          ''
        );
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function(evt) {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

      // only add the search parameters to the url if they exist
      search = search !== '' ? '?' + search : '';
     // console.log('search');
     // console.log(search);

      document.location.href = filter + search;
      this._resizeSelect($(evt.target));
    },

    _getFilterValue: function() {
      return this.$filterSelect.val();
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return CustomFilters;
})();

theme.HomeHalfAutoHeight = {};
theme.HomeHalfAutoHeight = (function() {
  function HomeHalfAutoHeight(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    this.selectors = {
      HomeHalfAutoHeightEl: '#HomeHalfAutoHeight'
    }
    this._initHomeHalfAutoHeight();
  }

  HomeHalfAutoHeight.prototype = $.extend({}, HomeHalfAutoHeight.prototype, {
    _initHomeHalfAutoHeight: function () {
      console.log('_initHomeHalfAutoHeight');
    },
    onUnload: function() {}
  });
  return HomeHalfAutoHeight;
})();


$(document).ready( function() {
  $(function() {
    // $("#date").datepicker( {
    //   minDate: +1,
    //   maxDate: '+2M'
    //
    // } );
    $('#date').datepicker({
      keyboardNavigation: false,
      forceParse: false,
      daysOfWeekDisabled: "0,6",
      calendarWeeks: true,
      autoclose: true,
      todayHighlight: true
  });
  });

  // $('.showmore').showMore({
	// 	speedDown: 300,
  //   speedUp: 300,
  //   height: '45px',
  //   showText: 'More',
  //   hideText: 'Less'
	// });
});

/*
 * Show More jQuery Plugin
 * Author: Jason Alvis
 * Author Site: http://www.jasonalvis.com
 * License: Free General Public License (GPL)
 * Version: 1.0.4
 * Date: 21.05.2013
 */

(function(a){a.fn.showMore=function(b){var c={speedDown:300,speedUp:300,height:"265px",showText:"Show",hideText:"Hide"};var b=a.extend(c,b);return this.each(function(){var e=a(this),d=e.height();if(d>parseInt(b.height)){e.wrapInner('<div class="showmore_content" />');e.find(".showmore_content").css("height",b.height);e.append('<div class="showmore_trigger"><span class="more">'+b.showText+'</span><span class="less" style="display:none;">'+b.hideText+"</span></div>");e.find(".showmore_trigger").on("click",".more",function(){a(this).hide();a(this).next().show();a(this).parent().prev().animate({height:d},b.speedDown)});e.find(".showmore_trigger").on("click",".less",function(){a(this).hide();a(this).prev().show();a(this).parent().prev().animate({height:b.height},b.speedUp)})}})}})(jQuery);
$(document).ready( function() {
  $('.city_anchor').click(function()
    {
      $('.city_anchor').removeClass('active');
      $(this).addClass('active');
      $('#country_name').val($(this).attr('val'));
      if($(this).attr('val')=="New York")
      {
        $("#london_map").addClass("hide");
        $("#nyc_map").removeClass("hide");
      }
      else
      {
        $("#nyc_map").addClass("hide");
        $("#london_map").removeClass("hide");
      }
    });

    /* For open enqiry form on bridal product*/
    $('body').click(function(e) {
        if (!$(e.target).is('.popup-overlay.size-guide') && !$(e.target).parents('.popup-overlay.size-guide').length && !$(e.target).is('.static-link.size-guide')) {
          if($(".popup-overlay.size-guide").hasClass('active'))
          {
            $("body").removeClass("drawer-open");
            $(".popup-overlay.size-guide").removeClass('active');
            $(".overlay").removeClass('active');
          }
        }
    });

    $("body.template-product .btn.btn-dark").click(function(e){
      var type = $(this).data('type');
      $("body").addClass("drawer-open");
      if (type == 'call-to-order') {
        //console.log($('.single-option-selector').val());
        $("body").removeClass("drawer-open");
      }
      $(".enquiry-form").removeClass("hide");
      $(".popup-overlay.enquriy-popup").addClass("active");
      $(".overlay").addClass('active');
    });

    $(document).on('click', '.notify-me-link.btn', function(e){
      e.preventDefault();
      var ael = document.querySelector('.notify-me.selected'),
      pro = document.querySelector('.product-single__title').innerText,
      sel = ael.getAttribute('data-value'),
      sub = 'Notify me when PRODUCT ' + pro + ' - ' + sel + ' is back in stock';
      document.querySelector('.popup-overlay.notifyme input[name="contact[subject]"]').value = sub;
      $(".popup-overlay.notifyme").addClass("active");
      $(".overlay").addClass('active');
    });

    if( $('.notifyme-form').find('p.form-message.form-message--success').length != 0 ){
      $(".popup-overlay.notifyme").addClass('active');
      $(".overlay").addClass('active');
    }

    if( $('.enquriy-popup').find('p.form-message.form-message--success').length != 0 ){
      $(".enquiry-js").addClass('active');
      $(".overlay").addClass('active');
    }

    $(".close-btn.product-close").click(function(e){
      e.preventDefault();
        $(".popup-overlay.enquriy-popup ").removeClass('active');
        $(".popup-overlay.notifyme").removeClass('active');
        $(".popup-overlay.size-guide").removeClass('active');
        $(".popup-overlay.shipping-returns").removeClass('active');
        $("body").removeClass("drawer-open");
        $('body').css('overflow','auto');
        $(".overlay").removeClass('active');
    });

    $("a.static-link.size-guide").click(function(){
      $(".popup-overlay.size-guide").addClass('active');
      $("body").addClass("drawer-open");
      $(".overlay").addClass('active');
    });

    /*Open shipping return popup*/
    $("a.static-link.shipping-returns").click(function(){
      $(".popup-overlay.shipping-returns").addClass('active');
      $("body").addClass("drawer-open");
      $(".overlay").addClass('active');
    });

    $('body').click(function(e) {
      if (!$(e.target).is('.popup-overlay.shipping-returns') && !$(e.target).is('.static-link.shipping-returns') && !$(e.target).parents('.popup-overlay.shipping-returns').length) {
        if($(".popup-overlay.shipping-returns").hasClass('active')){
          $("body").removeClass("drawer-open");
          $(".popup-overlay.shipping-returns").removeClass('active');
          $(".overlay").removeClass('active');
        }
      }
    });

    /*Enquiry popup on product detail*/

    $('body').click(function(e) {
      if (!$(e.target).is('.popup-overlay.enquriy-popup') && !$(e.target).is('.btn.btn-dark') && !$(e.target).parents('.popup-overlay.enquriy-popup').length) {
        if($(".popup-overlay.enquriy-popup").hasClass('active')){
          $("body").removeClass("drawer-open");
          $(".popup-overlay.enquriy-popup").removeClass('active');
          $(".overlay").removeClass('active');
        }
      }
    });

    /**
    * Stocking page dropdown
    */
    $('select.side-link-list').prettyDropdown({
      classic: true,
      height: 38,
      selectedMarker: ''
    });
    $('select.side-link-list').change(function() {
      window.location.href = $(this).val();
    });

    /*
     * Look book popup
     */
      $('.btn.enquire-submit').click(function(e){
      e.preventDefault();
      var cls = document.querySelectorAll('.enquiry-contact-form');
      for (var i = 0; i < cls.length; i++) {
         if(!cls[i].value){
            cls[i].classList.add('custom-form-error');
         }
         else {
            cls[i].classList.remove('custom-form-error');
         }
         if(cls[i].type == 'email') {
            var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            if (filter.test(cls[i].value)) {
                cls[i].classList.remove('custom-form-error');
            }
            else {
                cls[i].classList.add('custom-form-error');
            }
         }
       }
       if($('.custom-form-error').length == 0) {
          $( "#contact_form" ).submit();
       }
    });

    /*
     * Call to order
     */
      $('.btn.enquire-submit-js').click(function(e){
      e.preventDefault();
      var cls = document.querySelectorAll('.enquiry-contact-js');
      for (var i = 0; i < cls.length; i++) {
         if(!cls[i].value){
            cls[i].classList.add('custom-form-error');
         }
         else {
            cls[i].classList.remove('custom-form-error');
         }
         if(cls[i].type == 'email') {
            var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            if (filter.test(cls[i].value)) {
                cls[i].classList.remove('custom-form-error');
            }
            else {
                cls[i].classList.add('custom-form-error');
            }
         }
       }
       if($('.custom-form-error').length == 0) {
          //$( "#contact_form" ).submit();
          $(this).parents('form:first').submit();
       }
    });

    $('.lookbook_img').click(function(){
      var total_popup = jQuery('a.lookbook_img').length;
      console.log(total_popup);
      var counter = $(this).attr('value');
      if (counter == parseInt(total_popup)-1) {
        var next_popup = 0;
      } else {
        var next_popup = parseInt(counter)+1;
      }

      if (counter==0){
        var previous_popup = parseInt(total_popup)-1;
      }
      else{
        var previous_popup = parseInt(counter)-1;
      }
      var img_src = $('#img_'+counter).attr('src');
      var product_name = $('#product_name_'+counter).attr('value');
      var product_url = $('#product_url_'+counter).attr('value');
      console.log('#product_url_'+counter);
      if(product_url!=""){ console.log(product_url+" image click");
        $('.btn.btn-text.enquiry_form').addClass('hide');
        $('.btn.btn-text.product').removeClass('hide');
        $('a.btn.btn-text.product').attr('href',product_url);
      }else{
        $('a.btn.btn-text.product').attr('href','');
        $('.btn.btn-text.enquiry_form').removeClass('hide');
        $('.btn.btn-text.product').addClass('hide');
      }
      $('.anchor_slider.previous').attr('value',previous_popup);
      $('.anchor_slider.next').attr('value',next_popup);
      $('h2#popup_title').html(product_name);
      $('#prod_name').val(product_name);
      $('body').addClass('drawer-open');
      $('.popup-overlay.product-popup .product-view img').attr('src',img_src);
      $('.popup-overlay.product-popup').addClass('active');
    });

    $('.anchor_slider.previous').click(function(){
        var total_popup = jQuery('.lookbook_img').length;
        var counter = $(this).attr('value');
        if(counter==parseInt(total_popup)-1){
          var next_popup = 0;
        }
        else{
          var next_popup = parseInt(counter)+1;
        }
       if(counter==0){
          var previous_popup = parseInt(total_popup)-1;
        }
        else{
          var previous_popup = parseInt(counter)-1;
        }

        var img_src = $('#img_'+counter).attr('src');
        var product_name = $('#product_name_'+counter).attr('value');
        var product_url = $('#product_url_'+counter).attr('value');
        if( product_url != "" ){ console.log(product_url+" if prev");
          $('.btn.btn-text.enquiry_form').addClass('hide');
          $('.btn.btn-text.product').removeClass('hide');
          $('a.btn.btn-text.product').attr('href',product_url);
        }else{
          $('a.btn.btn-text.product').attr('href','');
          $('.btn.btn-text.enquiry_form').removeClass('hide');
          $('.btn.btn-text.product').addClass('hide');
        }

        $('.enquiry-form').addClass('hide');
        $('.anchor_slider.previous').attr('value',previous_popup);
        $('.anchor_slider.next').attr('value',next_popup);
        $('h2#popup_title').html(product_name);
        $('#prod_name').val(product_name);
        $('body').addClass('drawer-open');
        $('.popup-overlay.product-popup .product-view img').attr('src',img_src);
        $('.popup-overlay.product-popup').addClass('active');
    });

    $('.anchor_slider.next').click(function(){
        var total_popup = jQuery('.lookbook_img').length;
        var counter = $(this).attr('value');
        if(counter==parseInt(total_popup)-1){
          var next_popup = 0;
        }
        else{
          var next_popup = parseInt(counter)+1;
        }

        if(counter==0){
          var previous_popup = parseInt(total_popup)-1;
        }
        else{
          var previous_popup = parseInt(counter)-1;
        }

        var img_src = $('#img_'+counter).attr('src');
        var product_name = $('#product_name_'+counter).attr('value');
        var product_url = $('#product_url_'+counter).attr('value');
        if(product_url!=""){console.log(product_url+" if next");
          $('.btn.btn-text.enquiry_form').addClass('hide');
          $('.btn.btn-text.product').removeClass('hide');
          $('a.btn.btn-text.product').attr('href',product_url);
        }else{
          $('a.btn.btn-text.product').attr('href','');
          $('.btn.btn-text.enquiry_form').removeClass('hide');
          $('.btn.btn-text.product').addClass('hide');
        }

        $('.anchor_slider.previous').attr('value',previous_popup);
        $('.anchor_slider.next').attr('value',next_popup);
        $('h2#popup_title').html(product_name);
        $('#prod_name').val(product_name);
        $('body').addClass('drawer-open');
        $('.popup-overlay.product-popup .product-view img').attr('src',img_src);
        $('.popup-overlay.product-popup').addClass('active');
        $('.enquiry-form').addClass('hide');
    });


  	$('.normal-image').click(function(){
      var total_popup = jQuery('.normal-image').length;
      var counter = $(this).attr('value');
      if(counter==parseInt(total_popup)-1){
        var next_popup = 0;
      }else{
        var next_popup = parseInt(counter)+1;
      }

      if(counter==0){
        var previous_popup = parseInt(total_popup)-1;
      }
      else{
        var previous_popup = parseInt(counter)-1;
      }
      //var previous_popup = parseInt(counter)-1;
      var img_src = $('#img_'+counter).attr('src');
      var product_name = $('#product_name_'+counter).attr('value');
      $('.slider_anchor.previous').attr('value',previous_popup);
      $('.slider_anchor.next').attr('value',next_popup);
      $('h2#popup_title').html(product_name);
      $('#prod_name').val(product_name);
      $('body').addClass('drawer-open');
      $('.popup-overlay.product-popup .product-view img').attr('src',img_src);
      $('.popup-overlay.product-popup').addClass('active');
  	});

  	$('.close-btn').click(function(){
      $('body').removeClass('drawer-open');
  		$('.popup-overlay.product-popup').removeClass('active');
      $('a.btn.btn-text').removeClass('hide');
      $('button.btn.btn-text').addClass('hide');
      $('.enquiry-form').addClass('hide');
      $('.popup-overlay.product-popup .product-view > img').attr('src','');
  	});

    $('.slider_anchor.next').click(function(){
        var total_popup = jQuery('.normal-image').length;
        var counter = $(this).attr('value');
        if(counter==parseInt(total_popup)-1){
          var next_popup = 0;
        }
        else{
          var next_popup = parseInt(counter)+1;
        }

        if(counter==0){
          var previous_popup = parseInt(total_popup)-1;
        }
        else{
          var previous_popup = parseInt(counter)-1;
        }

        var img_src = $('#img_'+counter).attr('src');
        var product_name = $('#product_name_'+counter).attr('value');
        $('.slider_anchor.previous').attr('value',previous_popup);
        $('.slider_anchor.next').attr('value',next_popup);
        $('h2#popup_title').html(product_name);
        $('#prod_name').val(product_name);
        $('body').addClass('drawer-open');
        $('.popup-overlay.product-popup .product-view img').attr('src',img_src);
        $('.popup-overlay.product-popup').addClass('active');
        $('enquiry-form').addClass('hide');
        $('a.btn.btn-text').removeClass('hide');
    });

    $('.slider_anchor.previous').click(function(){
        var total_popup = jQuery('.normal-image').length;
        var counter = $(this).attr('value');
        if(counter==parseInt(total_popup)-1){
          var next_popup = 0;
        }
        else{
          var next_popup = parseInt(counter)+1;
        }
       if(counter==0){
          var previous_popup = parseInt(total_popup)-1;
        }
        else{
          var previous_popup = parseInt(counter)-1;
        }

        var img_src = $('#img_'+counter).attr('src');
        var product_name = $('#product_name_'+counter).attr('value');
        $('.enquiry-form').addClass('hide');
        $('a.btn.btn-text').removeClass('hide');
        $('.slider_anchor.previous').attr('value',previous_popup);
        $('.slider_anchor.next').attr('value',next_popup);
        $('h2#popup_title').html(product_name);
        $('#prod_name').val(product_name);
        $('body').addClass('drawer-open');
        $('.popup-overlay.product-popup .product-view img').attr('src',img_src);
        $('.popup-overlay.product-popup').addClass('active');
    });

    $('a.btn.btn-text.enquiry_form').click(function(){
      $('.enquiry-form').removeClass('hide');
      $('button.btn.btn-text').removeClass('hide');
      $('a.btn.btn-text').addClass('hide');
    });
});

var pdata = new Bloodhound({
  datumTokenizer: function(Obj) {
    return Bloodhound.tokenizers.whitespace([Obj.title+' ' + Obj.handle]);
  },
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  prefetch: '/pages/product-json'
});
$('.search .typeahead').typeahead(
  {
    hint: false
  },
  {
    searchOnFocus: true,
    display: ["title"],
    // templates: {
    //   empty: [
    //     '<div class="empty-message">',
    //       'unable to find any Best Picture winners that match the current query',
    //     '</div>'
    //   ].join('\n'),
    //   suggestion: '<div><strong>{{title}}</strong> – {{handle}}</div>'
    // },
    //template: '<span>' + '<span class="name">{{title}}</span>' + '</span>',
    href: '/products/{{handle}}',
    source: pdata,
    debug: false
});

// $('.typeahead').bind('typeahead:select', function(ev, suggestion) {
//   console.log('Selection: ' + suggestion.handle);
// });


/*================ Templates ================*/
var SLOVERS = SLOVERS || {};
$(function(){

  // USE STRICT
  "use strict";
  var log;
  log = function(value) {
    if (typeof console !== "undefined") {
      return console.log(value);
    }
  };
  SLOVERS.initialize = {
    init: function(){
      SLOVERS.initialize.menu();
      SLOVERS.initialize.blogLoading();
      SLOVERS.initialize.mobileMenu();
      SLOVERS.initialize.toggleFilter();
      SLOVERS.initialize.backToTop();
      SLOVERS.initialize.slideSectionDown();

    },
    blogLoading: function() {
      // Ajax Pagination auto load.
      var pInfScrLoading = false;
      var pInfScrDelay = 250;
      function pInfScrExecute() {
        var pInfScrNode = $('.more').last();
        console.log(pInfScrNode);
        var pInfScrURL = $('.more a').last().attr("href");
        if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
          $.ajax({
            type: 'GET',
            url: pInfScrURL,
            beforeSend: function() {
              pInfScrLoading = true;
              pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src=\"https://cdn.shopify.com/s/files/1/0022/5856/7228/files/loading.gif?v=1594978865\" />');
              pInfScrNode.hide();
            },
            success: function(data) {
              // remove loading feedback
              pInfScrNode.next().remove();
              pInfScrNode.remove();
              $('body,html').stop(true);
              var filteredData = $(data).find(".ajax-blog");
              var filteredMoreData = $(data).find(".more");
              filteredData.insertBefore( $("#product-list-foot") );
              filteredMoreData.insertAfter( $("#product-list-foot") );
              pInfScrLoading = false;
              attachClickEvent();
            },
            dataType: "html"
          });
        }
      }
      function attachClickEvent(){
        /*setTimeout(function() {
          SLOVERS.initialize.sameHeight();
        }, 5000);*/
        $('.more a').click(function(event){
          pInfScrExecute();
          event.stopPropagation();
          return false;
        });
        return false;
      }
      function autoScrollItem(event){
          pInfScrExecute();
          event.stopPropagation();
          return false;
      }
      attachClickEvent();
      if ($body.hasClass('template-blog')){
        $(window).on('click', $.debounce(250, function() {
          if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
            var pInfScrNode = $('.more').last();
            if (typeof pInfScrNode != 'undefined' && pInfScrNode) {
              $('.more a').last().trigger("click").remove();
            }
          }
        }));
      }
    },
    menu: function() {
      var dd = document.querySelectorAll('.dropdown-toggle');
      for (var i = 0; i < dd.length; i++) {
        dd[i].addEventListener('click', function (event) {
          event.preventDefault();
          var sel = '#' + this.getAttribute("data-child"),
          el = document.querySelector(sel);
          if (el.classList.contains('show')) {
            SLOVERS.initialize.closeMenu();
            var sh = document.querySelector('.site-header');
            sh&&sh.classList.remove('active');
          } else {
            var sh = document.querySelector('.site-header');
            sh&&sh.classList.add('active');
            SLOVERS.initialize.openMenu(sel);
          }
        });
      }

      var bdy = document.querySelector('body');
      bdy.addEventListener('click', function (e) {
        if (!$(e.target).is('.dropdown-menu') && !$(e.target).is('.nav-link')) {
          SLOVERS.initialize.closeMenu();
          var sh = document.querySelector('.site-header');
          sh&&sh.classList.remove('active');
        }
      });
    },
    closeMenu: function() {
      var dm = document.querySelectorAll('.dropdown-menu');
      $.each(dm, function(e, t) {
        t.parentNode.classList.remove('show');
        t.classList.remove('show');
      });
    },
    openMenu: function(e) {
      SLOVERS.initialize.closeMenu();
      var el = document.querySelector(e);
      el.parentNode.classList.add('show');
      el.classList.add('show');
      var sh = document.querySelector('.site-header');

        var mtop = sh.offsetHeight - sh.offsetHeight / 2;
        document.querySelector('.dropdown-menu.show').style['margin'] = '0';
        document.querySelector('.dropdown-menu.show').style['top'] = mtop + 'px';

    },
    mobileMenu: function() {
      var mc = document.querySelector('.menu-close');
      mc.addEventListener('click', function (event) {
        event.preventDefault();
        document.querySelector('.sm_menu_outer').classList.remove('active');
        document.querySelector('body').classList.remove('mmactive');
      });
    },
    hideLogoOnScroll: function() {
      var scroll = $(window).scrollTop();
      if (scroll >= 5) {
        $(".site-header").addClass("white-header");
        $(".logo").addClass("show");
        $(".center-logo").fadeOut(200);
      } else {
        $(".site-header").removeClass("white-header");
        $(".logo").removeClass("show");
        $(".center-logo").fadeIn(200);
      }
    },
    fixedProductActions: function() {
      var scroll = $(window).scrollTop() + 100;
      if($('.mobile-fix-section').length>0){
        var limit = $('.product-description').offset().top;
        if (scroll == 100) {
          $('.mobile-fix-section').hide();
        } else if (scroll < limit) {
          $('.mobile-fix-section').show();
        } else {
          $('.mobile-fix-section').hide();
        }
      }
    },
    toggleFilter: function() {
      var _self = theme.CustomFilters.prototype;
      $(document)
        .on('click', '.filter, .filter-close', function(e){
          e.preventDefault();
          document.querySelector('.filter-toggle-block').classList.toggle('active');
          document.querySelector('.filter').classList.toggle('active');
          if ($(".filter").hasClass('active')) {
            _self._SavedFilter("hide");
          } else {
            _self._SavedFilter("show");
          }
          document.querySelector('.result').classList.toggle('active');
          if(windowWidth < 768) {
            document.querySelector('.fiter-block').parentNode.classList.toggle('mobile-zindex');
            document.querySelector('body').classList.toggle('drawer-open');
            document.querySelector('.overlay').classList.toggle('active');
          }
        });
    },
    toggleBackToTop: function() {
      var scroll = $(window).scrollTop(),
      sh = document.querySelector('.site-header'),
      limit = (sh)?sh.offsetHeight:'',
      el = document.querySelector('.back-top');
      if (el) {
        if (document.body.scrollTop > limit || document.documentElement.scrollTop > limit) {
          el.style.display = "block";
        } else {
          el.style.display = "none";
        }
      }
    },

    backToTop: function(){
      var el = document.querySelector('.back-top');
      el && el.addEventListener('click', function (event) {
        event.preventDefault();
        $("html, body").animate({scrollTop: 0}, 1000);
      });
    },

    slideSectionDown: function () {
      var el = document.querySelector('.slide-section-down');
      el && el.addEventListener('click', function (event) {
        event.preventDefault();
        var sc = document.querySelector('.home-banner').offsetHeight - 50;
        $("html, body").animate({scrollTop: sc}, 1000);
      });
    }
  };

  SLOVERS.documentOnResize = {
    init: function(){}
  };

  SLOVERS.documentOnReady = {
    init: function(){
      SLOVERS.initialize.init();
      //$('.nav-box-image-wrapper img').fakecrop('center', 200, 200);

    }
  };

  SLOVERS.documentOnLoad = {
    init: function(){
      //SLOVERS.initialize.stickyElements();
    }
  };

  SLOVERS.documentOnScroll = {
    init: function(){
      SLOVERS.initialize.hideLogoOnScroll();
      SLOVERS.initialize.fixedProductActions();
      SLOVERS.initialize.toggleBackToTop();
    }
  };

  var $window = $(window),
  $body = $('body'),
  DOC = $(document),
  windowWidth = $window.width(),
  windowHeight= $window.height();
  $(document).ready( SLOVERS.documentOnReady.init );
  $window.on('load', SLOVERS.documentOnLoad.init);
  $window.on('scroll', SLOVERS.documentOnScroll.init);
  $window.on('resize', SLOVERS.documentOnResize.init );
});

/*!
/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};
/*
*
* jquery.imageslaoded.min.js
*/
!function(a,b){var c="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";a.fn.imagesLoaded=function(d){function e(){var b=a(m),c=a(n);i&&(n.length?i.reject(k,b,c):i.resolve(k)),a.isFunction(d)&&d.call(h,k,b,c)}function f(a){g(a.target,"error"===a.type)}function g(b,d){b.src===c||-1!==a.inArray(b,l)||(l.push(b),d?n.push(b):m.push(b),a.data(b,"imagesLoaded",{isBroken:d,src:b.src}),j&&i.notifyWith(a(b),[d,k,a(m),a(n)]),k.length===l.length&&(setTimeout(e),k.unbind(".imagesLoaded",f)))}var h=this,i=a.isFunction(a.Deferred)?a.Deferred():0,j=a.isFunction(i.notify),k=h.find("img").add(h.filter("img")),l=[],m=[],n=[];return a.isPlainObject(d)&&a.each(d,function(a,b){"callback"===a?d=b:i&&i[a](b)}),k.length?k.bind("load.imagesLoaded error.imagesLoaded",f).each(function(d,e){var f=e.src,h=a.data(e,"imagesLoaded");h&&h.src===f?g(e,h.isBroken):e.complete&&e.naturalWidth!==b?g(e,0===e.naturalWidth||0===e.naturalHeight):(e.readyState||e.complete)&&(e.src=c,e.src=f)}):e(),i?i.promise(h):h}}(jQuery);


var GALVAN = GALVAN || {};
(function($) {

  // USE STRICT
  "use strict";
  var log, cache = {}, classes = {};
  log = function(value) {
    if (typeof console !== "undefined") {
      return console.log(value);
    }
  };

  GALVAN.widget = {
    init: function() {
      GALVAN.widget.requestReturn();
      GALVAN.widget.closeOverlayPopup();
      GALVAN.widget.popup();
    },
    popup: function() {
      var checkContentOverflow, closeDialog, eventListeners, fillPopupDialog, fillSizeChartDialog, getCustomClasses, closeMeIcon, getImage, getNewsletter, getPageContent, getSocialIcons, getWrapper, centerPopUP, hideMask, ieCenter, isExpired, mask, maskIsActive, modal, modal_clazz, openDialog, passesExpiration, resetExpiration, showMask, storeExpiration, urlParam;
      modal = null;

      mask = $('.popup-modal-mask');
      storeExpiration = function() {
        var date, expires, object, seconds_from_now;
        date = new Date();
        seconds_from_now = 1000 * 60 * 60 * 24 * popup_config.days_until;
        expires = date.setTime(date.getTime() + seconds_from_now);
        object = {
          expires: expires
        };
        localStorage.removeItem('GALVAN_pageclick');
        return localStorage[popup_config.storage_key] = JSON.stringify(object);
      };
      resetExpiration = function() {
        console.log("expireddd");
        localStorage.removeItem(popup_config.storage_key);
        localStorage.removeItem('GALVAN_pageclick');
        return storeExpiration();
      };
      isExpired = function() {
        if (typeof localStorage[popup_config.storage_key] === "undefined" ) {
          return false;
        }
        var expires, now, object;
        object = JSON.parse(localStorage[popup_config.storage_key]);
        expires = object.expires;
        now = new Date().getTime();
        if (parseFloat(expires - now) <= 0) {
          console.log("expiressss111");
          resetExpiration();
          return true;
        }
        return false;
      };
      passesExpiration = function() {
        var passed, ObjClickCount;
        passed = false;

        var urlPar = urlParam();
        if (Storage === "undefined" || popup_config.days_until === "test_mode") {
          passed = true;
        }
        else if (urlPar != '' && urlPar != null) {
          storeExpiration();
          passed = false;
        }
         else if (typeof localStorage[popup_config.storage_key] === "undefined") {
          passed = true;
          storeExpiration();
        } else {
          //console.log("I am herer")
          passed = isExpired();
        }
        return passed;
      };
      maskIsActive = function() {
        return $('.popup-modal').is(':visible') || $('.modal-mask').length > 0 && $('.modal-mask').is(':visible');
      };
      showMask = function() {
        mask.show();
        return $('body').addClass("modal-on body-fade");
      };
      hideMask = function() {
        mask.hide();
        return $('body').removeClass("modal-on body-fade");
      };
      closeMeIcon = function() {
        return $('<button class="popup-modal-close newsletter-close">✕</button>');
      };
      urlParam = function() {
        var name = 'utm_medium';
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results==null) {
           return null;
        }
        return decodeURI(results[1]) || 0;
      };
      getImage = function() {
        if (popup_config.show_image_enabled !== true) {
          return "";
        }
        if (popup_config.image_link.length > 0) {
          return $('<div class="imgblock"><a href="' + popup_config.image_link + '"><img src="' + popup_config.show_image_url + '" alt=""></a></div>');
        } else {
          return $('<div class="imgblock">').append("<img src='" + popup_config.show_image_url + "' alt=''>");
        }
      };
      getNewsletter = function() {
        var subscribe_module;
        if (popup_config.newsletter_enabled === false) {
          return "";
        }

        subscribe_module = $("<div id='subscribe_module' class='sign-up-popup'></div>")
        //.append( "<h2>" + popup_config.popup_heading + "</h2>")
        .append($("#mc-embedded-subscribe-form").clone());

        return subscribe_module;
      };
      getSocialIcons = function() {
        if (popup_config.social_icons_enabled === false) {
          return "";
        }
        return $(".social-follow").clone();
      };
      getCustomClasses = function() {
        var class_list;
        class_list = "";
        class_list += popup_config.show_image_enabled === true ? " has-image" : " has-no-image";
        class_list += popup_config.popup_heading.length > 0 ? " has-page-content" : " has-no-page-content";
        class_list += popup_config.newsletter_enabled ? " has-newsletter" : " has-no-newsletter";
        class_list += popup_config.social_icons_enabled ? " has-social-icons" : " has-no-social-icons";
        class_list += " popup-overlay newsletter-modal home-newsletter active";
        return class_list;
      };
      getWrapper = function() {
        return '<dialog class="popup-modal newsletter-popup-modal' + getCustomClasses() + '" id="homepage-newsletter" />';
      };
      centerPopUP = function(){
        return $('<div class="popup-center"/>').append('<div class="newsletter-popup" />');
      };
      getPageContent = function() {
        var popup_heading;
        popup_heading = null;
        if (popup_config.popup_heading.length < 1) {
          return "";
        }
        $.getJSON('/pages/' + popup_config.popup_heading + '.json', function(data, textStatus) {
          return popup_heading = "<div class='page-contents'>" + data.page.body_html + "</div>";
        });
        return popup_heading;
      };
      fillSizeChartDialog = function() {
        var dialog;
        if ($('.popup-modal.size-chart').length < 1) {
          dialog = {
            wrapper: getWrapper()
          };
          $('body').append($(dialog.wrapper).append($('.size-chart')));
        }
        return openDialog();
      };
      fillPopupDialog = function() {
        var dialog, getInnerContent,  render;
        dialog = {
          wrapper: getWrapper(),
          closeMe: closeMeIcon(),
          image: getImage(),
          newsletter: getNewsletter(),
          social_icons: getSocialIcons()
        };
        getInnerContent = function() {
          if (popup_config.popup_heading.length < 1 && popup_config.newsletter_enabled === false && popup_config.social_icons_enabled === false) {
            return "";
          }
          return $("<div class='half-col  text-center padlr-80' />").append(dialog.body, dialog.newsletter, dialog.social_icons);
        };

        render = function() {
          //$('body').append($(dialog.wrapper));
           $('body').append($(dialog.wrapper).append(dialog.closeMe));
          $('<div class="form-block newsletter-popup-box clearfix"></div></div>').appendTo(".newsletter-modal" );
          $('.newsletter-popup-box').append(dialog.image, getInnerContent());
          return openDialog();
        };

        if (popup_config.popup_heading.length > 0) {
            return render();
          //return $.getJSON('/pages/' + popup_config.popup_heading + '.json', function(data, textStatus) {});
        } else {
          return render();
        }
      };
      checkContentOverflow = function() {
        return setTimeout((function() {
          if (modal.length > 0 && $('.popup-modal-mask').is(':visible')) {
            return modal.imagesLoaded(function() {
              if (modal.outerHeight() >= $window.height()) {
                return $('body').addClass('modal-unfix');
              } else {
                return $('body').removeClass('modal-unfix');
              }
            });
          }
        }), 0);
      };
      ieCenter = function() {
        return modal.css({
          marginTop: -(modal.outerHeight() * 0.5) + "px",
          marginLeft: -(modal.outerWidth() * 0.5) + "px"
        });
      };
      openDialog = function() {
        modal = $('dialog[class*="newsletter-popup-modal"]');
        if ($("html").hasClass("ie9")) {
          ieCenter();
        }
        eventListeners();
        modal.addClass("opened").removeClass("closed");
        checkContentOverflow();
        return showMask();
      };
      eventListeners = function() {
        var removeAnimation;
        removeAnimation = function(event) {
          if (event.originalEvent.animationName === 'modal-close') {
            if (modal_clazz === 'popup') {
              return modal.remove();
            } else {
              return modal.removeClass('closed, completed');
            }
          } else {
            return modal.addClass('completed').removeClass('opened');
          }
        };
        DOC.on('click', '.popup-modal', function(e) {
          e.stopPropagation();
          if (e.target === this) {
            return closeDialog();
          }
        });
        $('.popup-modal-close').click(closeDialog);
        $('.modal-close').click(function(e){
          e.preventDefault();
          return closeDialog();
        });
        mask.click(closeDialog);
        modal.on('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', removeAnimation);
        $window.resize(checkContentOverflow);
        DOC.keydown(function(e) {
          if (modal.hasClass('completed') && e.keyCode === 27) {
            return closeDialog();
          }
        });
        return $('dialog.popup-modal #contact_form').on('submit', function(event) {
          var form;
          form = this;
          modal = $(this).closest('.popup-modal');
          modal.find('.error, .success').remove();
          event.preventDefault();
          if (modal.find('input[type="email"]').val().length === 0) {
            modal.find('.inner').prepend('<p class="error">' + popup_config.newsletter_email_blank + '</p>');
            return false;
          } else {
            modal.find('.inner > *').hide();
            modal.find('.inner').prepend('<p class="success">' + popup_config.newsletter_success_message + '</p>').show();
            setTimeout(function() {
              return form.submit();
            }, 500);
          }
          return false;
        });
      };
      closeDialog = function() {
        modal.addClass('closed').removeClass('completed').removeClass('opened').removeClass("active");
        return hideMask();
      };

      //console.log('Popup Starts form here');
      var notfront = true;
      if (document.querySelector('body').classList.contains('template-index')) {
         notfront = false;
      }
      if (notfront && popup_config.enabled && passesExpiration() && (popup_config.popup_heading.length > 0 || popup_config.newsletter_enabled || popup_config.show_image_enabled || popup_config.social_icons_enabled)) {
        return setTimeout((function() {
          if (!(maskIsActive() === true || $('.popup-modal-mask').length < 1)) {
            return fillPopupDialog();
          }
        }), popup_config.seconds_until * 1000);
      }

    },
    requestReturn: function() {
      var rrl = '.request-return-module',
      el = document.querySelector(rrl),
      rb = document.querySelector('.return-block');
      if (el) {
      $('#ContactFormReason').prettyDropdown({
        classic: true
      })
        //needs to be passed to the snippet
        var order_date_string = el.getAttribute('data-orderdate'),
        //(should be 14 days) We could wire this up to theme settings
        number_of_days_for_an_exchange = el.getAttribute('data-maxreturn');
        var order_date = new Date(Date.parse(order_date_string));
        var now_date = new Date();
        var time_diff = Math.abs(now_date.getTime() - order_date.getTime());
        var diff_days = Math.ceil(time_diff / (1000 * 3600 * 24));

        //exchanges only allowed within 14 days.
        if(diff_days < number_of_days_for_an_exchange){
          //el.classList.remove('hide');
        } else {
          document.querySelector('.return-expired').classList.remove('hide');
        }

        el.addEventListener('click', function (event) {
          event.preventDefault();
          rb && rb.classList.toggle('hide');
        });

        //form is open if we have a message to display..
        var fm = document.querySelector('.form-message');
        if (fm){
        	rb.classList.toggle('hide');
        }

      }

      if($(".template-order").length){
         var chkId = '';
        $('.rtn-reason').click(function(e) {
          chkId = (this.id).match(/\d+/);
          if($(this).prop("checked") == true){
            var tdhtml = '<select id="ContactFormReason'+chkId+'" required="required" class="form-control return-req-select" name="contact[Reason For Item'+chkId+']"><option value="">Select a reason</option><option>Changed my mind</option><option>Quality</option><option>No longer need the item</option><option>Does not fit</option><option>Wrong item(s) received</option><option>Item(s) damaged</option><option>Look different to product image</option></select>';
            $(this).parent().parent().parent().find('td:last').html(tdhtml);
            //this.parentNode.parentNode.parentNode.appendChild(document.createElement('td')).innerHTML=tdhtml;
          }
          else if($(this).prop("checked") == false){
            //$(this.parentNode.parentNode.parentNode).find('td:last-child').remove();
            $(this).parent().parent().parent().find('td:last').html('');
          }
          GALVAN.widget.confirmReturn();
        });

        $(document).on('change', '.return-req-select', function() {
            var str2 = 'Does not fit';
          if(this.value.indexOf(str2) != -1) {
            var tdhtml = '<select id="ContactFormMoreDetails'+chkId+'" required="required" class="form-control form-more-reason" name="contact[More reason For Item'+chkId+']"><option value="">Select a reason</option><option>Item is too big</option><option>Item is too small</option><option>Torso length is too long</option><option>Torso length is too short</option><option>Too small at the bust</option><option>Too big at the bust</option><option>Too small at the waist / hip</option><option>Too big at the waist / hip</option></select>';
            $( this ).after( tdhtml );
          }
          else if ($(this).next().length > 0) {
            $( this ).next().remove();
          }
        });

        if(window.location.search==""){
          $(".address-info, .order-detail, .request-return-module").removeClass("hide");
        } else {
          $(".return-block").addClass("hide");
          var orderId = $("body").attr("id").match(/\d+/);
          var d = new Date();
          var month = d.getMonth()+1;
          var day = d.getDate();
          var year = d.getFullYear().toString().substr(2,2);
          var curDate = (day<10 ? '0' : '') + day + '/' + (month<10 ? '0' : '') + month + '/' + year ;
          var outData = "<div class='suc-data'><p>Date: " + curDate + "</br>Order number: #" + orderId + "</p><a href='#'' class='rtn-bck back'>BACK TO ORDER DETAILS</a></div>";
          $(".right-detail-block").append(outData);
        }

        $(".request-return-module").click(function(){
          $(".address-info, .order-detail, .request-return-module").addClass("hide");
        });

        $('.rtn-bck').click(function(e) {
          e.preventDefault();
          $(".return-block, .suc-data").addClass("hide");
          $(".address-info, .order-detail, .request-return-module").removeClass("hide");
          var result = GALVAN.widget.getParameterByName('contact_posted');
          if(result) {
            var formMessage = $(".form-message").text();
            $(".js-table table tr").each(function() {
              var id = $(this).attr("id");
              if(id != '' && id != undefined) {
                if(sessionStorage.getItem(id) != undefined && sessionStorage.getItem(id) != '') {
                  $("#" + id + " td a").after('<p class="confirm-msg">' + formMessage +'</p>');
                }
              }
            });
          $(".form-message--success").addClass("hide");
          }
        });

        $('.cfm-rtn').click(function(e) {
          var status = true;
          $('form#contact_form select').each(function() {
              var id = $(this).attr("id");
              if($("#" + id + ' option').filter(":selected").val() == "") {
                status = false;
                return false;
              }
          });
          if(status == true && $(this).val() == 'confirm return') {
            $(this).val("Continue");
            $('.return-request-data').removeClass("hide");
            $(".return.d-block .data-table").addClass("hide");
            $(".return.d-block h2").addClass("hide");
            $(".return-bottom p").addClass("hide");
            $(".return-bottom a").removeClass("rtn-bck");
            $(".return-bottom a").addClass("rtn-continue-bck");

            $(".rtn-reason").each(function(){
              var cls = $(this).data("count-val");
              var lineItem = $(this).data("lineItem");
              if($(this).prop("checked") == true){
                $("." + cls).removeClass("hide");
                $("." + cls).addClass("active-row");
               sessionStorage.setItem(lineItem, true);
              }
              else {
                $("." + cls).addClass("hide");
                $("." + cls).removeClass("active-row");
                sessionStorage.removeItem(lineItem);
              }
            });
            var total = 0;
            $(".return-request-data table tr.active-row td.total-price").each(function() {
              var price = $(this).data("price");
              total = parseInt( price ) + total;
            });
            $(".return-request-data table tr td.subtotal").html(Shopify.formatMoney(total, theme.moneyFormat))
            return false;
          }
          else if (status == true && $(this).val() == 'Continue') {
            return true;
          }
        });

        $(document).on('click', '.rtn-continue-bck', function(e) {
          e.preventDefault();
          $(".return-bottom a").addClass("rtn-bck");
          $(".return-bottom a").removeClass("rtn-continue-bck");
          $(".return-block, .data-table").removeClass("hide");
          $('.return-request-data').addClass("hide");
          $(".address-info, .order-detail, .request-return-module").addClass("hide");
          $(".cfm-rtn").val("confirm return");
        });
      }
    },

    confirmReturn: function(){
      var counter = 0;
      $(".rtn-reason").each(function(){
        if($(this).prop("checked") == true){
          counter = 1;
          $(".cfm-rtn").prop('disabled', false);
        }
        if(counter==0){
          $(".cfm-rtn").prop('disabled', true);
        }
      });
    },
    getParameterByName: function( name ) {
        var regexS = "[\\?&]"+name+"=([^&#]*)",
      regex = new RegExp( regexS ),
      results = regex.exec( window.location.search );
      if( results == null ){
        return "";
      } else{
        return decodeURIComponent(results[1].replace(/\+/g, " "));
      }
    },


    closeOverlayPopup: function() {
      var _self = theme.CustomFilters.prototype;
      var ov = document.querySelector('.overlay');
      ov && ov.addEventListener('click', function(event) {
        event.preventDefault();
        this.classList.remove('active');
        var bd = document.querySelector('body');
        if (bd.classList.contains('drawer-open')) {
          bd.classList.remove('drawer-open');
        }

        var op = document.querySelectorAll('.popup-overlay');
        for (var i = 0; i < op.length; i++) {
          op[i].classList.remove('active');
        }
        var fb = document.querySelector('.filter-toggle-block'),
        fl = document.querySelector('.filter');
        if($(window).width() < 768) {
          //fb && fb.classList.contains('active')? document.querySelector('body').classList.toggle('drawer-open'):'';
          fb && fb.classList.contains('active')? _self._SavedFilter("show") : '';
        }
        fb && fb.classList.contains('active')?fb.classList.remove('active'):'';
        fl && fl.classList.contains('active')?fl.classList.remove('active'):'';
      })
    }
  };

  GALVAN.documentOnReady = {
    init: function() {
      GALVAN.widget.init();
    }
  };

  var $window = $(window),
    $body = $('body'),
    DOC = $(document);
  /*var popup_config = {
    enabled: true,
    newsletter_enabled: true,
    social_icons_enabled  : false,
    show_image_enabled    : true,
    image_link: "",
    seconds_until: 5,
    show_image_url: '//dev.thebarnagency.co.uk/hb2/wp-content/themes/the-barn-hb/assets/img/GALVAN-popup-img.jpg',
    popup_heading: "JOIN THE MAILING LIST",
    popup_subheading: "GALVAN Bartley are opening an online pop-up store in November. Sign up to be the first to know.",
    days_until: "7",
    storage_key: 'GALVAN_popup_storage'
  };*/

  $(document).ready( GALVAN.documentOnReady.init );
})(jQuery);

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$('.addressesBlock').length) {
    return;
  }

  if ($newAddressForm.length) {
    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  /*$('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });*/

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('product-section', theme.ProductSection);

  sections.register('section-1-2-auto-height', theme.HomeHalfAutoHeight);
  sections.register('collection-template', theme.CustomFilters);

  $('span.item_count').empty();
  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  $(document).on('cart.requestComplete', function(event, cart) {
    if(!document.querySelector('body').classList.contains('template-cart')) {
      //theme.Custom.drawertoggle('.cart-popup');
      setTimeout(function(){
        document.querySelector('.cart-popup').classList.add('active');
        document.querySelector('body').classList.add('drawer-open');
        if($(window).width() > 786){
          document.querySelector('.overlay').classList.add('active');
        }
      }, 250);
    }
    if(cart.item_count == 0) {
      $('.item-count').html('');
      document.querySelector('.cart-popup').classList.remove('active');
      document.querySelector('body').classList.remove('drawer-open');
      document.querySelector('.overlay').classList.remove('active');
    }
    else {
      $('.item-count').html(cart.item_count);
    }
  });

  /*blog selector*/
  if ($('.selector-blog-tab').length > 0) {
    $("select").click(function() {
    var open = $(this).data("isopen");
    if(open) { window.location.href = $(this).val() }
    $(this).data("isopen", !open);
    });
  }

  if ($('.full-slider-image img').length > 0) {
    $(".full-slider-image img").after('<div class="count-imgs"></div>');
    var numImgs = $('.full-slider-image img').length;
    var txt1 = "<p>VIEW</p> ";  
    var txt3 = $("<span></span>").text(numImgs); 
    $(".count-imgs").append(txt1, txt3, ' Photos'); 

    }
  
  
});
